import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbInlineNotification } from "abreact/feedback/AbInlineNotification";
import * as React from "react";
export class AbForm extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onSubmit", async event => {
      this.props.onSubmit();
      event.preventDefault();
    });
  }
  render() {
    //Todo:  Andy A: Check to see if any child fields are, in fact, required, and set this next var accordingly
    let anyRequiredFields = !!this.props.showRequiredIndicators;
    const formClasses = [this.props.hideDecorators && "ab-hide-decorators", this.props.showRequiredIndicators && "ab-show-required-indicators"];
    return /*#__PURE__*/React.createElement("form", _extends({}, ReactUtils.componentProps("ab-form", this.props, formClasses), {
      autoComplete: this.props.autoComplete === false ? "off" : undefined,
      onSubmit: this.onSubmit
    }, this.props.__htmlProps), this.props.submitMessage && /*#__PURE__*/React.createElement(AbFormMessages, {
      submitMessage: this.props.submitMessage,
      failureMessages: this.props.submitDetailedMessages,
      validationIssues: this.props.validationIssues || []
    }), this.props.children, anyRequiredFields && this.props.showLegend && /*#__PURE__*/React.createElement("div", {
      className: "ab-form-legend"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ab-form-legend-content"
    }, AbReactResources.form_required())));
  }
}
export function AbFormMessages(props) {
  const messages = (props.failureMessages ?? []).concat(props.validationIssues.map(validationIssue => validationIssue.message));
  // ABSDK-3779: Added ab-flexible. Remove if unneeded here.
  return /*#__PURE__*/React.createElement(AbInlineNotification, _extends({}, ReactUtils.componentProps("ab-form-messages", props, ["ab-flexible"]), {
    dataTestId: props.dataTestId,
    message: props.submitMessage,
    severity: "error",
    details: messages.length > 0 && /*#__PURE__*/React.createElement("ul", {
      className: "validation-issues"
    }, messages.map((message, index) => {
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, message);
    }))
  }));
}
//# sourceMappingURL=AbForm.js.map
